<template lang="pug">
    .settings-section-head-wrapper
        h4.settings-title {{title}}
</template>

<script>
export default {
    name: "head-of-settings-section",
    props: {
        title: {
            type: String,
            require: true
        }
    }
}
</script>